/**
 * Generated by orval v7.20.0 🍺
 * Do not edit manually.
 * MALIYONE-LOAN-MANAGEMENT-API API
 * API specification for MALIYONE-LOAN-MANAGEMENT-API
 * OpenAPI spec version: 1.0.0
 */

/**
 * WITHDRAWN means the charge was taken off the pending list because a grace period granted later covers it. Unlike REJECTED it does not count as a decision, so the charge is proposed again once the grace period has run out. REVERSED means an approved or overridden charge was taken back off the account (#37).

 */
export type PenaltyReviewStatus = typeof PenaltyReviewStatus[keyof typeof PenaltyReviewStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PenaltyReviewStatus = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  OVERRIDDEN: 'OVERRIDDEN',
  WITHDRAWN: 'WITHDRAWN',
  REVERSED: 'REVERSED',
} as const;
